// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c59953c9","488":"65ee966e","805":"8912fff5","977":"f737ad8d"}[chunkId] + ".chunk.js";
};